import { useParams } from "react-router-dom";

export default function ExplorePage() {
  const { topic } = useParams();

  return (
    <div style={{ padding: "50px" }}>
      <h1>{topic.replace(/-/g, " ")}</h1>
      <p>This is the Explore page for: {topic}</p>
    </div>
  );
}
